var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6501_55700)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6501_55700",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6501_55700)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0.888672L20 6.38867L17.25 6.88867L14.5 6.38867L14 3.63867L14.5 0.888672Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6.38867V0.888672H5.5C4.67125 0.888672 4 1.55992 4 2.38867V21.3887C4 22.2174 4.67125 22.8887 5.5 22.8887H18.5C19.3288 22.8887 20 22.2174 20 21.3887V6.38867H14.5Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9.38867V16.6387H17V9.38867H7ZM11.375 15.3887H8.25V13.6387H11.375V15.3887ZM11.375 12.3887H8.25V10.6387H11.375V12.3887ZM15.75 15.3887H12.625V13.6387H15.75V15.3887ZM15.75 12.3887H12.625V10.6387H15.75V12.3887Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6501_55700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.6ebf48cf5ba3ee3cd385b035b22cc8f6.svg";
export { ForwardRef as ReactComponent };